<template>
    <Card class="col-span-12 md:col-span-3 relative">
        <template #content>
            <div class="space-y-4">
                <div>
                    <Image
                        class="max-h-32 w-auto mx-auto object-cover"
                        :src="providerData.thumbUrl"
                    />
                </div>
                <div class="text-xs font-semibold uppercase text-gray-600">
                    {{ providerData.label }}
                </div>
            </div>
            <div class="mt-2 flex flex-col justify-end gap-1">
                <Button
                    as="a"
                    :href="providerData.redirectUrl"
                    size="small"
                    color="light"
                    iconName="arrow-right"
                    :iconRight="true"
                >
                    Connect
                </Button>
            </div>
        </template>
    </Card>
</template>

<script setup lang="ts">
    import Card from '@/Shared/Component/Card.vue'
    import { type IntegrationProviderDataType } from '@/Shared/AutoGenerated/Main'
    import type { PropType } from 'vue'
    import Button from '@/Shared/Component/Button.vue'
    import Image from '@/Shared/Component/Image.vue'

    const emit = defineEmits(['onSuccess'])

    const props = defineProps({
        providerData: {
            type: Object as PropType<IntegrationProviderDataType>,
            required: true,
        },
    })
</script>
